/* ═══════════════════════════════════════════════════════════════
   Basisstand — der zuletzt mit dem Server bestätigte Kellerbuchstand

   Die Dreiwegezusammenführung (kern/dreiwege.js) braucht den Stand,
   von dem Gerät und Server beide ausgegangen sind. Im Speicher steht
   er nach jedem bestätigten Speichern ohnehin; hier wird er zusätzlich
   abgelegt, damit er einen Neustart übersteht — der typische Fall ist
   ja: offline gearbeitet, App geschlossen, später wieder geöffnet.

   IndexedDB und nicht localStorage: Dort liegt bereits die lokale
   Kopie, und eine zweite gleich große würde das Kontingent (meist
   5 MB) bei großen Kellern sprengen — mit der lokalen Kopie als
   erstem Opfer. Eigene Datenbank statt eines weiteren Speichers in
   „winelake“ (Fotowarteschlange), damit keine Versionsanhebung der
   anderen nötig ist.

   Alles hier darf scheitern: Ohne Basis wird schlicht nicht
   zusammengeführt, es bleibt bei der Rückfrage.
   ═══════════════════════════════════════════════════════════════ */

const DB_NAME = "winelake-basis";
const LADEN = "basis";

let verbindung = null;

function oeffne() {
  if (verbindung) return verbindung;
  verbindung = new Promise((fertig, fehler) => {
    if (typeof indexedDB === "undefined") { fehler(new Error("IndexedDB steht nicht zur Verfügung.")); return; }
    const anfrage = indexedDB.open(DB_NAME, 1);
    anfrage.onupgradeneeded = () => {
      const d = anfrage.result;
      if (!d.objectStoreNames.contains(LADEN)) d.createObjectStore(LADEN);
    };
    anfrage.onsuccess = () => fertig(anfrage.result);
    anfrage.onerror = () => fehler(anfrage.error || new Error("IndexedDB konnte nicht geöffnet werden."));
    anfrage.onblocked = () => fehler(new Error("IndexedDB ist blockiert."));
  });
  verbindung.catch(() => { verbindung = null; });
  return verbindung;
}

function vorgang(modus, arbeit) {
  return oeffne().then((d) => new Promise((fertig, fehler) => {
    const t = d.transaction(LADEN, modus);
    const anfrage = arbeit(t.objectStore(LADEN));
    t.oncomplete = () => fertig(anfrage ? anfrage.result : undefined);
    t.onerror = () => fehler(t.error);
    t.onabort = () => fehler(t.error || new Error("Vorgang abgebrochen."));
  }));
}

/* Schreiben in Folge: Kommen zwei Bestätigungen kurz nacheinander,
   darf die ältere die jüngere nicht überholen. */
let kette = Promise.resolve();

/** Basis ablegen — als Zeichenkette, das spart dem Browser die
    strukturierte Kopie eines großen Objektbaums. */
function merkeBasis(benutzername, version, daten) {
  if (!benutzername || daten == null) return Promise.resolve();
  let text;
  try { text = JSON.stringify(daten); } catch (e) { return Promise.resolve(); }
  kette = kette
    .then(() => vorgang("readwrite", (s) => s.put({ version, text }, benutzername)))
    .catch(() => { /* ohne Basis eben ohne Zusammenführung */ });
  return kette;
}

/** { version, daten } oder null. */
async function ladeBasis(benutzername) {
  if (!benutzername) return null;
  try {
    await kette;
    const e = await vorgang("readonly", (s) => s.get(benutzername));
    if (!e || typeof e.text !== "string") return null;
    return { version: e.version, daten: JSON.parse(e.text) };
  } catch (e) {
    return null;
  }
}

function vergissBasis(benutzername) {
  if (!benutzername) return Promise.resolve();
  kette = kette
    .then(() => vorgang("readwrite", (s) => s.delete(benutzername)))
    .catch(() => {});
  return kette;
}

export { ladeBasis, merkeBasis, vergissBasis };
